'use client';
import { SWRConfig as SWRConfig$1 } from '../_internal/index.mjs';

const SWRConfig = SWRConfig$1;

export { SWRConfig as S };
